<script lang="ts">
  import { track } from "../../../common/utils/track.ts";
  import { useHost } from "../../../common/runtime/utils/useHost.ts";

  const Host = useHost();

  /*                                                                                                                               */
  let clientHeight = $state(0);
  let headlineLines = $derived.by(() => {
    track(clientHeight);
    const headlineSlotElement = Array.from(Host.children).find(
      (child) => child.slot === "headline",
    );
    if (!headlineSlotElement) return 0;
    const lineHeight = parseFloat(getComputedStyle(headlineSlotElement).lineHeight);
    return lineHeight ? Math.ceil(clientHeight / lineHeight) : 0;
  });
</script>

<slot></slot>
<slot name="img"></slot>
<div part="text">
  <svelte:element this={"slot"} name="headline" bind:clientHeight></svelte:element>
  <svelte:element this={"slot"} name="subline" style:--headline-lines={headlineLines}
  ></svelte:element>
</div>
<slot name="action-signifier"></slot>
